import { render, staticRenderFns } from "./teamDialog.vue?vue&type=template&id=78645d4f&scoped=true"
import script from "./teamDialog.vue?vue&type=script&lang=js"
export * from "./teamDialog.vue?vue&type=script&lang=js"
import style0 from "./teamDialog.vue?vue&type=style&index=0&id=78645d4f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78645d4f",
  null
  
)

export default component.exports